import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const appConfigService = {
    getAll,
    getAllAppConfigs,
    addAppConfig,
    updateAppConfig,
    deleteAppConfig,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/app-config/getAllAppConfigs/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllAppConfigs() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/app-config/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addAppConfig(newAppConfig) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newAppConfig),
    };

    const response = await fetch(
        `${config.oat_api_url}/app-config/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateAppConfig(appConfigItem, appConfigId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(appConfigItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/app-config/update/${appConfigId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteAppConfig(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/app-config/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
